module.exports = __webpack_public_path__ + "gd.svg?51b37f949e3215057da83eba06fc64e2";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/gd.svg
// module id = 1004
// module chunks = 27